<script setup lang="ts">
import VbList from "@/components/crud/VbList.vue"
import VbListSearchFilterButton from "@/components/crud/VbListLoginSearchFilterButton.vue"
import VbListSearch from "@/components/crud/VbListSearch.vue"
import VbListToolbar from "@/components/crud/VbListToolbar.vue"
import { useLoginSearchFilter } from "@/composables/useLoginSearchFilter"
import FilterProjectsDropdown from "@/pages/Tasks/Customer/FilterProjectsDropdown.vue"
import FilterDoneIssuesDropdown from "@/pages/Tasks/Issue/FilterDoneIssuesDropdown.vue"
import { type ListState } from "@/vf"
import { ref } from "vue"
import { useRouter } from "vue-router"
import FilterOnlyMessagesButton from "../Issue/FilterOnlyMessagesButton.vue"
import FilterMyOrganizationsDropdown from "../Issue/FilterOrganizationsDropdown.vue"
import { createModuleConfiguration } from "./config"

const props = withDefaults(
    defineProps<{
        allowNew?: boolean
    }>(),
    { allowNew: true },
)

const router = useRouter()
const filterOnlyMessages = ref(false)
const config = createModuleConfiguration("tasks/issue", filterOnlyMessages)
config.list.newButton = () => props.allowNew
let listState: ListState

const listId = config.list?.id()
const loginSearchFilter = useLoginSearchFilter()

function onLoaded({ listState: newState }: { listState: ListState }) {
    listState = newState
    if (router.currentRoute.value.query.issue) {
        listState.columnClicked(
            { id: router.currentRoute.value.query.issue as string },
            { name: "virtual", title: "virtual", type: "string" },
        )
    }
    loginSearchFilter.init(listId, listState)
}

const originalShow = config.show.page
config.show.page = item => {
    const listItem = listState?.list?.find(i => i.id === item.id)
    if (listItem) {
        listItem.unreadMessagesCount = 0
    }
    return originalShow(item)
}
</script>

<template>
    <VbList :config="config" @loaded="onLoaded">
        <template #toolbar="{ refresh }">
            <VbListToolbar></VbListToolbar>
            <FilterOnlyMessagesButton
                v-bind="{ config }"
                @toggle="filterOnlyMessages = $event"
                class="card-toolbar__item"
            ></FilterOnlyMessagesButton>
            <FilterDoneIssuesDropdown v-bind="{ config }" class="card-toolbar__item"></FilterDoneIssuesDropdown>
            <FilterProjectsDropdown
                v-bind="{ admin: false, config }"
                class="card-toolbar__item"
            ></FilterProjectsDropdown>
            <FilterMyOrganizationsDropdown
                v-bind="{ config }"
                :customer-view="true"
                class="card-toolbar__item"
            ></FilterMyOrganizationsDropdown>
            <VbListSearch @search="refresh()" class="card-toolbar__item"></VbListSearch>
            <div>
                <VbListSearchFilterButton
                    v-bind="{ filter }"
                    v-for="filter in loginSearchFilter?.getFilters(listId)"
                    :key="filter.id"
                    :class="{ 'btn-primary-dark': filter.active }"
                    class="card-toolbar__item"
                    @click="loginSearchFilter?.loadFilter(filter)"
                ></VbListSearchFilterButton>
            </div>
        </template>
    </VbList>
</template>
